import axiosBase from "axios";
import axios from "./axiosInstance";
import {
  RAKE_DOCUMENTS,
  RAKE_DOCUMENT_PRESIGN,
  RAKE_DOCUMENT_CONFIRM,
  DELETE_RAKE_DOCUMENT,
} from "./apiEndPoints";
import {
  IRakeDocument,
  IRakeDocumentPresign,
} from "../components/types/rake.types";

export const MAX_RAKE_DOCUMENT_BYTES = 25 * 1024 * 1024; // 25 MB

export async function listRakeDocuments(
  rakeMasterId: string
): Promise<IRakeDocument[]> {
  const res = await axios.get(RAKE_DOCUMENTS(rakeMasterId));
  const documents = res.data?.data?.documents;
  return Array.isArray(documents) ? documents : [];
}

export async function uploadRakeDocument(
  rakeMasterId: string,
  file: File
): Promise<void> {
  if (file.size > MAX_RAKE_DOCUMENT_BYTES) {
    throw new Error("File exceeds the 25MB limit");
  }
  const mimeType = file.type || "application/octet-stream";

  const presignRes = await axios.post(RAKE_DOCUMENT_PRESIGN(rakeMasterId), {
    fileName: file.name,
    mimeType,
    fileSize: file.size,
  });
  const { uploadUrl, s3Key } = presignRes.data.data as IRakeDocumentPresign;

  await axiosBase.put(uploadUrl, file, {
    headers: { "Content-Type": mimeType },
  });

  await axios.post(RAKE_DOCUMENT_CONFIRM(rakeMasterId), {
    s3Key,
    fileName: file.name,
    mimeType,
    uploadSource: "web",
  });
}

export async function deleteRakeDocument(
  rakeDocumentId: string
): Promise<void> {
  await axios.delete(DELETE_RAKE_DOCUMENT(rakeDocumentId));
}
